import {computed, Fragment, observer, React} from '@api'
import {LayoutStore, SplitterNode, TabSet, TabSetNode, useLayoutStore} from '@flexlayout'

export class TabSetsStore {
  constructor(public store: LayoutStore) {
  }

  @computed get tabSetNodes() {
    const {store: {model: {_idMap}}} = this

    return _.values(_idMap).filter(v => v instanceof TabSetNode) as TabSetNode[]
  }
}

export const TabSets = observer(function TabSets() {
  const store = useLayoutStore(),
    {tabSets: {tabSetNodes}, props: {iconFactory, icons, titleFactory}} = store
//tabSetComponents.push(<TabSet key={child.id} layout={store} node={child} iconFactory={iconFactory} titleFactory={titleFactory} icons={icons}/>)

  // console.log(tabSetNodes)
  return (<Fragment>
    {tabSetNodes.map(child => <TabSet key={child.id} layout={store} node={child} iconFactory={iconFactory} titleFactory={titleFactory} icons={icons}/>)}
  </Fragment>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/TabSets.tsx